import React, { createContext, useContext } from 'react'
import { useAsyncResource } from '../hooks/useAsyncResource'
import { getHomeSections, parseWordpressRes } from '../services/cms'
import { localhomePageSectionsData } from 'data/homePageSections'

const HomeSectionsContext = createContext(null)

export function HomeSectionsProvider ({ children }) {
  const resource = useAsyncResource(async (signal) => {
    try {
      return await getHomeSections({ signal })
    } catch {
      return parseWordpressRes(localhomePageSectionsData)
    }
  })

  const value = {
    homePageSections: resource.data,
    isHomeSectionsLoading: resource.loading,
    homeSectionsError: resource.error,
    fetchHomeSections: resource.load
  }

  return (
    <HomeSectionsContext.Provider value={value}>{children}</HomeSectionsContext.Provider>
  )
}

export const useHomeSections = () => {
  const ctx = useContext(HomeSectionsContext)
  if (!ctx) throw new Error('useHomeSections must be used within <HomeSectionsProvider>')
  return ctx
}
